{
  "title": "Comparando hangares",
  "buttons": {
    "stack": "Configuración"
  },
  "resultGrid": {
    "columns": {
      "hangar": "Hangar",
      "progress": "Progreso",
      "variants": "# Variantes",
      "placed": "# Colocados",
      "duration": "Duración",
      "utilization": "Utilización",
      "topUtilizations": "Top 4 utilizaciones",
      "viewResults": "Ver resultados"
    }
  }
}
